import { render, staticRenderFns } from "./UiLoader.vue?vue&type=template&id=5977a3ea&lang=pug&"
import script from "./UiLoader.vue?vue&type=script&lang=ts&"
export * from "./UiLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports